import { Head, Link } from '@inertiajs/react';
import { MainLayout } from '../../layouts/MainLayout';
import { route } from '../../utils/route';
import type { CompanyWelcomeProps } from '../../types/company-setup';

export default function Welcome({ companyName, promoDiscount }: CompanyWelcomeProps) {
    return (
        <MainLayout>
            <Head>
                <title>¡Bienvenido! | Abasto Virtual</title>
                <meta name="robots" content="noindex" />
            </Head>

            <div className="flex min-h-[60vh] items-center justify-center px-4 py-12">
                <div className="w-full max-w-md rounded-2xl bg-white p-8 text-center shadow-lg">
                    <img
                        src="https://cdn.abastovirtual.com/img/logo.webp"
                        alt="Logo de AbastoVirtual"
                        className="mx-auto mb-6 w-48"
                    />

                    <div className="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-green-100">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" className="h-10 w-10 text-green-600">
                            <path d="M20 6L9 17l-5-5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>

                    <h1 className="mb-3 text-2xl font-bold text-green-600">
                        ¡Felicitaciones!
                    </h1>

                    <p className="mb-4 text-gray-600">
                        Ya podés comprar en AbastoVirtual con <strong>{companyName}</strong>.
                    </p>

                    <div className="mb-8 rounded-xl bg-green-50 p-4">
                        <p className="text-sm text-green-800">
                            <strong>¡Beneficio especial!</strong> Durante tu primer mes tenés
                            <strong> Mayorista Premium con {promoDiscount}% de descuento</strong> en todos los productos.
                        </p>
                    </div>

                    <Link
                        href={route('products.index')}
                        className="inline-block rounded-xl bg-green-500 px-6 py-3 font-bold text-white transition-colors hover:bg-green-600 hover:text-white hover:no-underline"
                    >
                        Ir a la tienda
                    </Link>
                </div>
            </div>
        </MainLayout>
    );
}
